//if the user leaves a field blank, error class is added for border color
jQuery('#edit-submit').click(function () {
    if (jQuery('.user-login-form #edit-name').val() == '') {
        jQuery('.user-login-form #edit-name').addClass("error");
    }else {
        jQuery('.user-login-form #edit-name').removeClass("error");

    };
    if (jQuery('.user-login-form #edit-pass').val() == '') {
        jQuery('.user-login-form #edit-pass').addClass("error");
    }
    else {
        jQuery('.user-login-form #edit-pass').removeClass("error");
    };
    if (jQuery('.user-login-form #edit-name').hasClass("error")) {
        jQuery('.user-login-form #edit-pass').addClass("error");
    }
});

var layoutForm = jQuery(".node-layout-builder-form");
if ( layoutForm.length > 0 ) {
  jQuery(layoutForm).parents(".cd-main-content").addClass("layout-edit-form");
}
